// extracted by mini-css-extract-plugin
export default {"menuList":"controls_menuList__yQooj","menuItem":"controls_menuItem__CiPQV","controlsList":"controls_controlsList__YGhCY","controlsItem":"controls_controlsItem__QcQt4"};